/* eslint-disable max-len */
import set from '@platform/adapter/clipboard/api/set'
import get from '@platform/adapter/clipboard/api/get'
import has from '@platform/adapter/clipboard/api/has'

/**
 * @memberOf Adapter.Clipboard#
 * @typedef Adapter.Clipboard.API
 *
 * Gathers methods used to manage notes.
 *
 * @property {function} getText - gets the text of the clipboard
 * @property {function} setText - sets the text of the clipboard
 * @property {function} getData - gets the data of the clipboard
 * @property {function} setData - sets the data of the clipboard
 * @property {function} hasText - returns whether the clipboard has text
 * @property {function} hasData - returns whether the clipboard has data
 *
 * @param {Gaia.Web.Application|Gaia.Mobile.Application} app  the platform application
 * @returns {{}}
 */
const api = app => Object.create({}, {
  getText: {
    value: get(app, 'text'),
    iterable: true,
    enumerable: true,
  },
  setText: {
    value: set(app, 'text'),
    iterable: true,
    enumerable: true,
  },
  getData: {
    value: get(app, 'data'),
    iterable: true,
    enumerable: true,
  },
  setData: {
    value: set(app, 'data'),
    iterable: true,
    enumerable: true,
  },
  hasData: {
    value: has(app, 'data'),
    iterable: true,
    enumerable: true,
  },
  hasText: {
    value: has(app, 'text'),
    iterable: true,
    enumerable: true,
  },
})

export default api
